export default "__VITE_ASSET__C4HDVY_b__"